import PropTypes from 'prop-types';
import React from 'react'

import { changeEmailFrequency } from '~/actions/profiles'


export default class extends React.Component {
    static propTypes = {
		message: PropTypes.object,
		className: PropTypes.string,
	};

    static contextTypes = {
		store: PropTypes.object
	};

    state = {
        frequency: this.props.email_frequency
    };

    changeSelection = (frequency) => {
		this.context.store.dispatch( changeEmailFrequency(frequency) )
		this.setState({
			frequency: frequency
		})
	};

    render() {

		let options = ['Daily', 'Weekly', 'Never']

		return (

			<div className={"panel stretch p20 mleft10 mleft0-xs " + this.props.className} id="emailSettings">

				<h3 className="mtop0 mbot20">Email Notifications</h3>

				{ this.props.message || <p className="mtop0 mbot20">How often would you like to receive emails?</p> }

				<div className="spread-buttons text-center">
					{
						options.map((option)=>{
							let lower = option.toLowerCase();
							return <button 
								className={"btn " + (this.state.frequency === lower ? "btn-primary" : "btn-secondary")}
								onClick={ this.changeSelection.bind(this, lower) }
								key={'email-frequency-'+lower}>
								{option}
							</button>
						})
					}
				</div>

			</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Body/components/EmailFrequency.jsx